// extracted by css-extract-rspack-plugin
export default {"showTwoLinehidden":"showTwoLinehidden-TPJYbn"};